import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

function PictureMenu({
  pictureMenuAnchorEl,
  setPictureMenuAnchorEl,
  setOpenUploadModal,
  setOpenRemovePictureModal,
  hasImage
}) {
  const [pendingAction, setPendingAction] = useState(null);

  const handleClose = () => {
    setPictureMenuAnchorEl(null);
  };

  const handleChangePicture = () => {
    setPendingAction("upload");
    handleClose();
  };

  const handleRemovePicture = () => {
    setPendingAction("remove");
    handleClose();
  };

  const handleExited = () => {
    if (pendingAction === "upload") {
      setOpenUploadModal(true);
    }

    if (pendingAction === "remove") {
      setOpenRemovePictureModal(true);
    }

    setPendingAction(null);
  };

  return (
    <Menu
      anchorEl={pictureMenuAnchorEl}
      open={Boolean(pictureMenuAnchorEl)}
      onClose={handleClose}
      TransitionProps={{ onExited: handleExited }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <MenuItem onClick={handleChangePicture}>Change Picture</MenuItem>
      {hasImage && <MenuItem onClick={handleRemovePicture}>Remove Picture</MenuItem>}
    </Menu>
  );
}

export default PictureMenu;